import { render, staticRenderFns } from "./thread_inactive_empty_state.vue?vue&type=template&id=0b2bfb20"
import script from "./thread_inactive_empty_state.vue?vue&type=script&lang=js"
export * from "./thread_inactive_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports